import { useEffect, useRef } from 'react';
import { gsap } from 'gsap';

export default function MagneticButton({ children, className, href, onClick }) {
    const magneticRef = useRef(null);

    useEffect(() => {
        const el = magneticRef.current;
        if (!el) return;

        // Use standard gsap.to instead of quickTo for better broad compatibility and simpler tuning if needed
        const handleMouseMove = (e) => {
            const { clientX, clientY } = e;
            const { height, width, left, top } = el.getBoundingClientRect();
            
            // Calculate distance from center of element to mouse
            const x = clientX - (left + width / 2);
            const y = clientY - (top + height / 2);
            
            // The pull factor (lower = subtler movement)
            const strength = 0.3;
            
            gsap.to(el, {
                x: x * strength,
                y: y * strength,
                duration: 1,
                ease: "power3.out",
                overwrite: "auto"
            });
        };

        const handleMouseLeave = () => {
            gsap.to(el, {
                x: 0,
                y: 0,
                duration: 1,
                ease: "elastic.out(1, 0.3)",
                overwrite: "auto"
            });
        };

        el.addEventListener("mousemove", handleMouseMove);
        el.addEventListener("mouseleave", handleMouseLeave);

        return () => {
            el.removeEventListener("mousemove", handleMouseMove);
            el.removeEventListener("mouseleave", handleMouseLeave);
        };
    }, []);

    const Element = href ? 'a' : 'button';

    return (
        <Element 
            href={href} 
            onClick={onClick}
            ref={magneticRef} 
            className={`inline-flex items-center justify-center cursor-pointer will-change-transform ${className || ''}`}
        >
            {children}
        </Element>
    );
}
